module.exports = __webpack_public_path__ + "static/media/festivality-bird.6b934fde.svg";